import { create } from 'zustand'

type GolfWindState = {
  speed: number
  directionDeg: number
  setWind: (speed: number, directionDeg: number) => void
}

export const useGolfWindStore = create<GolfWindState>((set) => ({
  speed: 0,
  directionDeg: 0,
  setWind: (speed, directionDeg) => set({ speed, directionDeg }),
}))

